<template>
    <div>
        <div class="card my-3">
            <div class="card-header">
                参加的培训班级
            </div>
            <div class="card-body" style="min-height: 600px">
                
                    <div v-for="(cls, index) in studyClassData" :key="index" class="card" :class="{'mt-3': index !== 0}">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-6">
                                    {{cls.className}}
                                </div>
                                <!-- <div class="col-6 text-right">
                                    {{cls.studentClassStateName}}
                                </div> -->
                            </div>
                        </div>
                        <table class="table table-bordered mb-0">
                            <tbody>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">批次信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.batchName }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm" @click="btnShowProjectBatchInfoDialog_Click(cls.batchId)">
                                                批次基本信息
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">项目信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.projectName }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectInfo_Click(cls.projectId)">项目基本信息
                                            </button>
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectTeacherCourse_Click(cls.projectId)">
                                                课程安排信息
                                            </button>
                                            <button class="btn btn-info btn-sm" @click="btnShowProjectAssessment_Click(cls.projectId)">项目考核信息
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">班级信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.className }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowStartClassNotificationDialog_Click(cls.classId)">开班通知
                                            </button>
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowClassScheduleDialog_Click(cls.classId)">
                                                教学日程信息
                                            </button>
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowResourceFileDialog_Click(cls.classId)">教学资料下载</button>
                                            <button class="btn btn-info btn-sm" @click="btnShowScoreDialog_Click(cls.studentClassId)">培训成绩查询</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">培训基地</th>
                                <td class="text-left align-middle" colspan="5">
                                    <a href="#" @click="btnShowOrganInfo_Click(cls.organId)">{{cls.organName}}</a>
                                </td>
                                <th class="text-center align-middle" style="width: 10%">联系人</th>
                                <td class="text-left align-middle" style="width: 15%">
                                    <a href="#" @click="btnShowClassContactInfoDialog_Click(cls.contactPersonId)">{{cls.personName}}</a>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">班级确认状态</th>
                                <td class="text-left align-middle" colspan="7" style="width: 10%">{{cls.studentClassStateName}}</td>
                            </tr>
                            <tr v-if="cls.studentClassState===studentClassState.V1_NON_CONFIRM">
                                <th class="text-center align-middle" style="width: 10%">院校确认状态</th>
                                <td class="text-left align-middle"  colspan="7">{{cls.collegeConfirmStateName}}</td>
                                <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                                <!-- <th class="text-center align-middle"  colspan="2">主管部门确认状态11</th>
                                <td class="text-left align-middle"  colspan="2">{{cls.adminConfirmStateName}}</td> -->
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">开始日期</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.startDateString}}</td>
                                <th class="text-center align-middle" style="width: 10%">结束日期</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.endDateString}}</td>
                                <th class="text-center align-middle" style="width: 10%">成绩</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.score}}</td>
                                <th class="text-center align-middle" style="width: 10%">班级状态</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.classStateName}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="card-footer text-center">
                            <button class="btn btn-primary mr-2"
                                    v-if="cls.studentClassState===studentClassState.V3_CHECK_IN"
                                    @click="btnShowAchievementEdit_Click(cls.projectId)">成果物提交</button>

                        </div>
                    </div>
            </div>
        </div>

        <b-modal v-model="isShowProjectInfoViewDialogOpen"
                 title="项目实施详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-info-view :project-id="projectId"></project-info-view>
        </b-modal>
        <b-modal v-model="isShowProjectTeacherCourseViewDialogOpen"
                 title="课程安排详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-teacher-course-view :project-id="projectId"></project-teacher-course-view>
        </b-modal>
        <b-modal v-model="isShowProjectAssessmentViewDialogOpen"
                 title="项目考核详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-assessment-view :project-id="projectId"></project-assessment-view>
        </b-modal>

        <b-modal v-model="isShowProjectBatchInfoDialogOpen"
                 title="项目批次详细信息"
                 ok-title="确定" :ok-only="true" size="xl"
                 :no-close-on-backdrop="true">
            <project-batch-info-view :batch-id="batchId"></project-batch-info-view>
        </b-modal>

        <b-modal v-model="isShowClassContactViewDialogOpen"
                 title="联系人详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <person-basic-info-view :person-id="personId" :show-detail-info="false"></person-basic-info-view>
            <person-contact-info-view :person-id="personId" class="mt-3"></person-contact-info-view>
        </b-modal>

        <b-modal v-model="isShowClassScheduleInfoDialogOpen"
                 title="班级教学日程安排信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-class-schedule-view :class-id="classId"></project-class-schedule-view>
        </b-modal>

        <b-modal v-model="isShowOrganInfoDialogOpen"
                 title="项目培训基地信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <organ-info-view :organ-id="organId" :show-warning-text="false"></organ-info-view>
        </b-modal>

        <b-modal v-model="isShowAchievementEditDialog"
                 title="项目成果物提交" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <student-achievment-edit :project-id="projectId"
                                     :user-id="$store.state.userInfo.userId"
                                     :user-name="$store.state.userInfo.userName"
                                     :user-type="$store.state.userType"></student-achievment-edit>
        </b-modal>

        <b-modal v-model="isShowResourceFileDialog"
                 title="教学资料下载" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <class-training-resource-edit :class-id="classId" :can-edit="false"></class-training-resource-edit>
        </b-modal>

        <b-modal v-model="isShowScoreDialog"
                 title="成绩查询" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <student-score-edit :student-class-id="studentClassId"></student-score-edit>
        </b-modal>

        <b-modal v-model="isShowStartClassNotificationDialogOpen"
                 title="开班通知管理" size="xl"
                 :hide-footer="true"
                 :no-close-on-backdrop="true">
            <start-class-notification-edit :class-id="classId" :can-edit="false"></start-class-notification-edit>
        </b-modal>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import studyApi from "@/utils/api/study";
import OrganInfoView from "@/components/user/OrganInfoView";
import ProjectInfoView from "@/components/infoView/ProjectInfoView";
import ProjectTeacherCourseView from "@/components/project/project/ProjectTeacherCourseView";
import ProjectAssessmentView from "@/components/project/project/ProjectAssessmentView";
import PersonBasicInfoView from "@/views/organ/OrganPersonBasicInfoView";
import PersonContactInfoView from "@/views/organ/OrganPersonContactInfoView";
import ProjectBatchInfoView from "@/components/infoView/ProjectBatchInfoView";
import ProjectClassScheduleView from "@/components/project/project/ProjectClassScheduleView";
import StudentAchievmentEdit from "@/components/study/StudentAchievmentEdit";
import ClassTrainingResourceEdit from "@/components/study/ClassTrainingResourceEdit";
import StudentScoreEdit from "@/components/study/StudentScoreEdit";
import StartClassNotificationEdit from "@/components/study/StartClassNotificationEdit";
export default {
    name: "StudentStudyClassManage",
    components: {
        StudentScoreEdit,
        ClassTrainingResourceEdit,
        StudentAchievmentEdit,
        OrganInfoView,
        ProjectInfoView,
        ProjectTeacherCourseView,
        ProjectAssessmentView,
        PersonContactInfoView,
        PersonBasicInfoView,
        ProjectBatchInfoView,
        ProjectClassScheduleView,
        StartClassNotificationEdit,
    },
    data: function () {
        return {
            studentClassState: dictionary.studentClassState,

            studentId: this.$store.state.userInfo.userId,

            studyClassData: [],

            batchId: '',
            projectId: '',
            personId: '',
            classId: '',
            organId: '',
            studentClassId: '',

            isShowProjectInfoViewDialogOpen: false,
            isShowProjectTeacherCourseViewDialogOpen: false,
            isShowProjectAssessmentViewDialogOpen: false,
            isShowProjectBatchInfoDialogOpen: false,
            isShowClassContactViewDialogOpen: false,
            isShowClassScheduleInfoDialogOpen: false,
            isShowOrganInfoDialogOpen: false,

            isShowAchievementEditDialog: false,

            isShowResourceFileDialog: false,
            isShowScoreDialog: false,

            isShowStartClassNotificationDialogOpen: false,
        };
    },
    mounted() {
        this.getProjectClassData();
    },
    methods: {
        getProjectClassData() {
            studyApi.studentClass.getStudentClassDataByStudentId(this.studentId).then(res => {
                this.studyClassData = res.data;
            });
        },

        btnShowProjectInfo_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectInfoViewDialogOpen = true;
        },
        btnShowProjectTeacherCourse_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectTeacherCourseViewDialogOpen = true;
        },
        btnShowProjectAssessment_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectAssessmentViewDialogOpen = true;
        },

        btnShowProjectBatchInfoDialog_Click(batchId) {
            this.batchId = batchId;
            this.isShowProjectBatchInfoDialogOpen = true;
        },

        btnShowClassContactInfoDialog_Click(contactPersonId) {
            this.personId = contactPersonId;
            this.isShowClassContactViewDialogOpen = true;
        },
        btnShowClassScheduleDialog_Click(classId) {
            this.classId = classId;
            this.isShowClassScheduleInfoDialogOpen = true;
        },
        btnShowOrganInfo_Click(organId) {
            this.organId = organId;
            this.isShowOrganInfoDialogOpen = true;
        },


        btnShowAchievementEdit_Click(projectId) {
            this.projectId = projectId;
            this.isShowAchievementEditDialog = true;
        },
        btnShowResourceFileDialog_Click(classId) {
            this.classId = classId;
            this.isShowResourceFileDialog = true;
        },
        btnShowScoreDialog_Click(studentClassId) {
            this.studentClassId = studentClassId;
            this.isShowScoreDialog = true;
        },

        btnShowStartClassNotificationDialog_Click(classId) {
            this.classId = classId;
            this.isShowStartClassNotificationDialogOpen = true;
        }
    }
}
</script>

<style scoped>

</style>